/** Only https on login.microsoftonline.com may be navigated to. */
export const isMicrosoftLoginUrl = (url: string): boolean => {
  try {
    const u = new URL(url);
    return (
      u.protocol === "https:" && u.hostname === "login.microsoftonline.com"
    );
  } catch {
    return false;
  }
};
